export default __webpack_public_path__ + "static/media/Avatar-26-noback.499b136b.png";